import styles from './QualityControlHandler.module.css';

import qualityControlIcon from '../../../../assets/svg/quality-control-01.svg';

import AddResourceButton from '../../SchemeButtons/AddResourceButton';
import useContextMenu from '../../../../hooks/useContextMenu';
import useOutsideClick from '../../../../hooks/useOutsideClick';
import { schemesStore } from '../../../../store/mobx/schemes.store';
import QualityControlSelectMenu from '../../SchemeMenus/QualityControlSelectMenu';
import { SchemeModes, SchemeNodeTypes } from '../../../../consts/scheme.consts';
import { useSchemeEditorContext } from '../../SchemeEditorProvider';
import classNames from 'classnames';
import Icon from '../../../../helpers/components/Icon';
import MenuDivider from 'components/SchemeEditor/SchemeUI/MenuDivider';
import passedSuccessIcon from 'assets/svg/window_ok-01.svg';
import passedWarningIcon from 'assets/svg/cancel-circle.svg';
import Tooltip from 'ui/Tooltip';
import QualityWrapper from 'components/QualityWrapper';

const QualityControlHandler = ({ node }) => {
  const [
    qualityControlMenuOpened,
    qualityControlMenuPosition,
    openQualityControlMenu,
    closeQualityControlMenu,
    qualityControlMenuRef,
  ] = useContextMenu();

  const { upsertSchemeNode } = schemesStore;
  const { schemeMode } = useSchemeEditorContext();

  useOutsideClick(qualityControlMenuRef, closeQualityControlMenu);

  const handleUpdateProtocol = async (value) => {
    await upsertSchemeNode({
      ...node,
      id_quality: value,
    });
  };

  const QualityControl = ({ item }) =>
    item && (
      <QualityWrapper node={item} key={`quality-${node.id}`}>
        <div
          className={classNames(styles.objectItem, {
            [styles.active]: qualityControlMenuOpened,
            [styles.editable]: schemeMode === SchemeModes.edit,
          })}
          onClick={(e) => schemeMode === SchemeModes.edit && openQualityControlMenu(e)}
        >
          <div className={styles.objectIconContainer}>
            <div className={classNames(styles.containerImg, styles.containerImgSize)}>
              <Icon
                src={qualityControlIcon}
                width={24}
                height={24}
                color={'var(--color-brand)'}
                className={classNames(styles.itemImg, styles.qualityControlImage)}
              />
            </div>
          </div>
          <div className={styles.objectTitle}>{item?.name ?? item?.protocol?.name ?? ''}</div>
          {qualityControlMenuOpened && <MenuDivider />}
          {getControlCheckIcon(item)}
        </div>
      </QualityWrapper>
    );

  const getControlCheckIcon = (item) => {
    if (item?.passed === null || item?.passed === undefined) return null;

    if (item?.passed) {
      return (
        <Tooltip text={'Пройден'}>
          <Icon
            src={passedSuccessIcon}
            width={24}
            height={24}
            color={'var(--color-node-success)'}
            className={classNames(styles.itemImg, styles.qualityControlImage)}
          />
        </Tooltip>
      );
    }

    return (
      <Tooltip text={'Не пройден'}>
        <Icon
          src={passedWarningIcon}
          width={29}
          height={29}
          color={'var(--color-node-error)'}
          className={classNames(styles.itemImg, styles.qualityControlImage)}
        />
      </Tooltip>
    );
  };

  return (
    <div className={styles.resourceItemContainer}>
      <QualityControl
        item={
          node?.quality || node.children?.find((obj) => obj.type === SchemeNodeTypes.qualityControl)
        }
      />

      {!node?.quality && schemeMode === SchemeModes.edit && (
        <AddResourceButton
          title={'Добавить контроль качества'}
          onClick={openQualityControlMenu}
          active={qualityControlMenuOpened}
        />
      )}
      {qualityControlMenuOpened && (
        <QualityControlSelectMenu
          ref={qualityControlMenuRef}
          position={{
            top: qualityControlMenuPosition.top,
            bottom: qualityControlMenuPosition.bottom,
            left: '100%',
          }}
          protocol={{ ...node.quality }}
          onSelect={handleUpdateProtocol}
          onClose={closeQualityControlMenu}
        />
      )}
    </div>
  );
};

export default QualityControlHandler;
